<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="margin-top: 20px">
    <el-form-item label="设备名称" prop="deviceName">
      <el-input class="form-input" v-model="form.deviceName" placeholder="请输入"></el-input>
    </el-form-item>
    <el-form-item label="所属乡镇">
      <el-select :popper-append-to-body="false" popper-class="form-select-dropdown" v-model="form.town" class="form-select" placeholder="请选择">
        <el-option
          v-for="item in townshipList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="经度">
      <el-input class="form-input" placeholder="请输入经度" v-model="form.longitude"></el-input>
    </el-form-item>
    <el-form-item label="纬度">
      <el-input class="form-input" placeholder="请输入纬度" v-model="form.latitude"></el-input>
    </el-form-item>
    <el-form-item label="点位图片">
      <el-upload
        class="avatar-uploader"
        action=""
        :on-change="upLoadImage"
        :show-file-list="false"
        accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
        :auto-upload="false">
        <img v-if="form.image" :src="baserUrl + form.image" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        <div v-if="form.image" class="remove" @click.stop="handleRemove">x</div>
      </el-upload>
    </el-form-item>
    <div class="foot">
      <div class="cancel" @click="cancel">取消</div>
      <div class="confirm" @click="confirm">确定</div>
    </div>
  </el-form>
</template>

<script>
import { townshipList } from "../../../../utils/common";
import { baserUrl } from "../../../../plugins/BsaeUrl";
import { uploadFile } from "../../../../api/common";

export default {
  name: "AddEidt",
  props: {
    info: { type: Object, default: () => {} }
  },
  data () {
    return {
      townshipList: townshipList,
      form: {
        job: '',
        tel: '',
        town: ''
      },
      baserUrl,
      rules: {
        deviceName: { required: true, message: '请输入设备名称', trigger: 'blur' },
        tel: { required: true, message: '请输入电话号码', trigger: 'blur' }
      }
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.info))
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    confirm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form)
          this.$emit('close')
        } else {
          return false;
        }
      });
    },
    handleRemove () {
      this.form.image = ''
    },
    upLoadImage (file){
      let formData = new FormData()
      formData.append("file", file.raw)
      uploadFile(formData).then(res => {
        this.form.image = res.data
      })
    },
  }
}
</script>

<style scoped lang="less">
  .form-input,.form-select{
    width: 420px;
    height: 40px;
  }
  .foot{
    display: flex;
    width: 100%;
    justify-content: center;
    div{
      cursor: pointer;
      width: 200px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      font-size: 22px;
      background-size: 100% 100%;
    }
    .cancel{
      background-image: url("~@/assets/img/box2.png");
      color: #00FFF6;
    }
    .confirm{
      background-image: url("~@/assets/img/box4.png");
      color: #00B2FF;
    }
  }

/deep/ .el-form-item{
  margin-bottom: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader{
  position: relative;
  .remove{
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ff0000;
    text-align: center;
    line-height: 7px;
    color: #FFFFFF;
    top: -5px;
    left: 95px;
    font-size: 12px;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #00B2FF;
  border-radius: 5px;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
